import React, { useState } from 'react';
import SelectorArrowDown from '../../images/selector-arrow-down.svg';
// import i18n from '../utils/i18n';

const SelectorDropdown = ({
	initialValue,
	id,
	label,
	options,
	placeholder = '-',
	isRequired = false,
	showAsterix = false,
	onSelect,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selected, setSelected] = useState({ label: '', value: '' });

	// let translation = '';
	// useEffect(() => {
	// 	switch (initialValue) {
	// 		case 'bt':
	// 			translation = i18n.t('companyforms.bt');
	// 			break;
	// 		default:
	// 			translation = 'KAKUKK';
	// 	}
	// }, []);

	const handleSelect = (option) => {
		setSelected(option);
		setIsOpen(false);
		if (onSelect) {
			onSelect(option);
		}
	};

	const displayOptions = options;

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				position: 'relative',
			}}>
			<label
				style={{
					fontSize: '14px',
					color: '#4b5080',
					fontWeight: 500,
					margin: '8px 0',
				}}>
				{label}
				{showAsterix && isRequired && (
					<span style={{ color: selected ? '#4b5080' : '#ff0000' }}> *</span>
				)}
			</label>
			<div
				onClick={() => setIsOpen(!isOpen)}
				style={{
					fontSize: '14px',
					border: `1px solid ${isOpen ? '#3b82f6' : '#d1d5db'}`,
					borderRadius: '8px',
					padding: '12px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					cursor: 'pointer',
					transition: 'border-color 0.3s ease',
				}}>
				{/* <span style={{ color: selected ? '#111827' : '#9ca3af' }}>
					{initialValue || placeholder}
				</span> */}
				<span style={{ color: selected ? '#111827' : '#9ca3af' }}>
					{selected.label ||
						options.find((opt) => opt.value === initialValue)?.label ||
						placeholder}
				</span>
				<img
					src={SelectorArrowDown}
					alt='DropdownArrow'
					style={{ width: '12px', height: '12px' }}
				/>
			</div>
			{isOpen && (
				<div
					style={{
						fontSize: '14px',
						position: 'absolute',
						top: '100%',
						left: 0,
						right: 0,
						border: '1px solid #d1d5db',
						borderRadius: '8px',
						marginTop: '4px',
						boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
						backgroundColor: '#ffffff',
						zIndex: 1000,
					}}>
					{displayOptions.map((option) => (
						<div
							id={option.value}
							key={option.value}
							onClick={() => handleSelect(option)}
							style={{
								padding: '8px 12px',
								cursor: 'pointer',
								color: '#111827',
								borderRadius: '8px',
								transition: 'background-color 0.2s ease',
							}}
							onMouseEnter={(e) =>
								(e.currentTarget.style.backgroundColor = '#e8eafe')
							}
							onMouseLeave={(e) =>
								(e.currentTarget.style.backgroundColor =
									selected === option ? '#ffffff' : '#ffffff')
							}>
							{option.label}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default SelectorDropdown;
